<template>
  <v-app
    id="materialpro"
    :class="`${
      !$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'
    }`"
  >
  <title>{{ dynamic_clr.meta_tag }}</title>
  <router-view />
  </v-app>
</template>
  
  <script>
import axios from "axios";
export default {
  name: "App",
  data: () => ({
    dynamic_clr: [],
  }),
  components: {},
  methods: {
    async getDynamicClr() {
      let cache_dynamic_clr = JSON.parse(localStorage.getItem("dynamic_clr"));
      if(cache_dynamic_clr != null){
        this.dynamic_clr = cache_dynamic_clr;
        return;
      }

      await axios
        .post(this.$apiurl + "api/web/customizer/get-dynamic-colors")
        .then(async (res) => {
          this.dynamic_clr = await res.data.data;
          localStorage.setItem("dynamic_clr", JSON.stringify(this.dynamic_clr));
          const favicon = document.getElementById("fav_icon");
          favicon.href = this.dynamic_clr.fav_icon;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getDynamicClr();
  },
};
</script>
<style scoped>
.swal2-popup{
  font-family: Inter;
}

</style>